import React from "react";
import { Location } from "../Location";
import { BookingEdit } from "@bookings/BookingEdit/BookingEdit";

interface Params {
  bookingId?: string;
}

export class BookingEditLocation extends Location<Params> {
  constructor(bookingId?: string) {
    super({ bookingId });
  }

  render() {
    const { bookingId } = this.params;
    return <BookingEdit id={bookingId} />;
  }

  toURI() {
    const { bookingId } = this.params;
    return `/bookings/${bookingId || "new/edit"} `;
  }
}
